import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import './styles/tokens.css';
import './styles/base.css';
import './styles/instrument.css';
import './ui/ui.css';
import './app/views/views.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Evaluation data changes when a person acts, not on a timer.
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const status = (error as { status?: number })?.status;
        if (status && status >= 400 && status < 500) return false;
        return failureCount < 2;
      },
    },
  },
});

const tree = (
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
);

const container = document.getElementById('root')!;

// The marketing pages are prerendered, so they hydrate: a click on the hero
// button has to work even if it lands before the bundle finishes. Entry
// animations wait for `useHydrated`, which keeps the first render identical to
// the server's markup. App routes have no server markup and render fresh.
if (container.childElementCount > 0) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}
